import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { getOrders } from "../../redux/apiCalls"
import * as timeago from "timeago.js"
import { format } from "timeago.js"
import fr from "timeago.js/lib/lang/fr"
import en from "timeago.js/lib/lang/en_US"
import { Visibility } from "@mui/icons-material"
// Components
import Table from "../Table/Table"
// Styles
import { Container, StyledLink } from "./Orders.styles"

const Orders = ({ userId }) => {
   const dispatch = useDispatch()
   const { t } = useTranslation()
   timeago.register("fr", fr)
   timeago.register("en", en)
   const orders = useSelector((state) => state.order.orders)
   const language = useSelector((state) => state.environment.language)

   const formatDate = (date, language) => {
      if (!date) return ""
      return format(date, language)
   }

   useEffect(() => {
      getOrders(userId, dispatch)
   }, [userId, dispatch])

   const statusTranslation = {
      delivered: t("orders.value.status.s1"),
      pending: t("orders.value.status.s2"),
      cancelled: t("orders.value.status.s3"),
      partial: t("orders.value.status.s4"),
   }

   const headers = [
      { name: t("orders.header.h1"), width: 10, align: "left" },
      { name: t("orders.header.h2"), width: 20, align: "left" },
      { name: t("orders.header.h3"), width: 15, align: "right" },
      { name: t("orders.header.h4"), width: 20, align: "right" },
      { name: t("orders.header.h5"), width: 30, align: "center" },
      { name: t("orders.header.h6"), width: 15, align: "center" },
   ]
   let data = []

   for (let i = orders.length - 1; i >= 0; i--) {
      data.push([
         orders[i].openOrderNumber
            ? orders[i].openOrderNumber
            : orders[i].orderNumber,
         formatDate(orders[i].orderDate, language),
         orders[i].totalQuantity,
         orders[i].amount + "€",
         statusTranslation[orders[i].status],
         <StyledLink to={`/order/${orders[i]._id}`}>
            <Visibility />
         </StyledLink>,
      ])
   }

   return (
      <Container>
         <Table headers={headers} data={data} pageSize={5} />
      </Container>
   )
}

Orders.propTypes = {
   userId: PropTypes.string,
}

export default Orders
